<template>
  <v-select
    :items="items"
    v-model="selected"
    :item-text="itemText"
    :item-value="itemValue"
    :multiple="multiple"
    :error-messages="errorMessages"
    solo
    dense
  >
    <template v-slot:label>
      <v-icon left color="grey">{{ inputIcon }}</v-icon>
      <slot></slot>
    </template>
    <template v-slot:prepend-item v-if="allSelector && multiple">
      <v-list-item @click="selectAll">
        <v-list-item-action>
          <v-icon>{{ allSelectorIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>すべて</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
    </template>
    <template v-slot:selection="{ item, index }" v-if="allSelector && multiple">
      <span class="text-truncate" v-if="index < 1">
        {{ item[itemText] }}
      </span>
      <span v-if="index === 1" class="grey--text ml-1">
        ( +{{ value.length - 1 }} )
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'FilterSelector',
  props: {
    value: {
      type: [Array, String, Object],
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemValue: {
      type: String,
      required: false,
      default: 'id'
    },
    itemText: {
      type: String,
      required: false,
      default: 'name'
    },
    inputIcon: {
      type: String,
      required: false,
      default: 'mdi-select'
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    },
    allSelector: {
      type: Boolean,
      required: false,
      default: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessages: {
      type: Array,
      required: false
    },
    label: {
      type: String,
      required: false
    }
  },
  components: {},
  data: () => ({
    selected: null
  }),
  computed: {
    allSelected() {
      let allSelected = false
      if (this.multiple && this.selected) {
        allSelected = this.selected.length === this.items.length
      }

      return allSelected
    },
    someSelected() {
      let someSelected = false
      if (this.multiple && this.selected) {
        someSelected = this.selected.length > 0 && !this.allSelected
      }

      return someSelected
    },
    allSelectorIcon() {
      if (this.allSelected) return 'mdi-checkbox-marked'
      if (this.someSelected) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    selectAll() {
      this.$nextTick(() => {
        if (this.allSelected) {
          this.selected = []
        } else {
          this.selected = this.items.map(e => e[this.itemValue])
        }
      })
    },
    updateValue() {
      this.$emit('input', this.selected)
    }
  },
  watch: {
    selected() {
      this.updateValue()
    }
  },
  updated() {
    if (this.value.length > 0) {
      if (this.multiple) {
        this.selected = this.value
      } else {
        this.selected = this.value
      }
    }
  }
}
</script>
